export enum UserGroupsTag {
  AutoActivation = 'AutoActivation',
  Name = 'Name',
  Path = 'Path'
}

export const UserGroupsTagsMap = new Map<UserGroupsTag, { tagKey: string; prop: string }>([
  [UserGroupsTag.Path, { tagKey: ':grid.path', prop: 'Path' }],
  [UserGroupsTag.Name, { tagKey: ':grid.name', prop: 'Name' }],
  [
    UserGroupsTag.AutoActivation,
    {
      tagKey: ':grid.autoActivate',
      prop: 'AutoActivationMode'
    }
  ]
]);
